module.exports = __webpack_public_path__ + "static/media/irridation2.704a1a09.jpg";